export default function CAEditCustomerLogoDirective() {
  return {
    template: require('./edit-customer-azure.directive.html'),
    scope: {
      customer: '=',
    },
    controller: 'CAEditCustomerAzureDirectiveController',
    controllerAs: 'editCustomerAzureVM',
    bindToController: true,
    replace: true,
  };
}
